export const version = "wallet/5.0.7";
//# sourceMappingURL=_version.js.map